import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatListOption } from "@angular/material/list";
import { AdvancedCommand } from "@vp/models";
import { AdvancedCommandsDialogComponent } from "@vp/virtual-care/feature-advanced-commands";
import { DynamicAssignmentComponent } from "@vp/virtual-care/ui/dynamic-assignment";
import { filter, map } from "rxjs/operators";
export interface AssignFilterBar {
  name: string;
  columnProp: string;
  options?: string[];
  modelValue?: string;
}
export interface AssignColumnDef {
  key: string;
  width?: number;
  header?: string;
}
/**
 * Properties must be passed.
 * If columns are passed, the AssignColumDef key must match the corresponding value in properties.
 */
export interface AssignOptions {
  properties?: string[]; // displayedColumns
  columnDefs?: AssignColumnDef[];
  filterBar?: AssignFilterBar[];
  excludeProperties?: string[];
  multiple?: boolean;
  title?: string;
  button?: string;
  noRecords?: string;
  selectedLabelKey?: string;
  selectedKey?: string;
}

export interface AssignData {
  items: Record<string, unknown>[];
  options: AssignOptions;
}

@Injectable({
  providedIn: "root"
})
export class AssignService {
  matDialog = inject(MatDialog);

  open = (items: Record<string, any>[], options?: AssignOptions) => {
    const dialogRef = this.matDialog.open(DynamicAssignmentComponent, {
      disableClose: true,
      autoFocus: false,
      closeOnNavigation: true,
      data: {
        items: items,
        options: options
      } as AssignData,
      panelClass: "mat-mdc-dialog"
    });

    return dialogRef.afterClosed().pipe(
      filter(
        (dialogResult): dialogResult is { selected?: MatListOption[]; muteChanged: boolean } =>
          !!dialogResult && Array.isArray(dialogResult.selected) && dialogResult.selected.length > 0
      ),
      map(dialogResult => {
        const muteChanged = dialogResult.muteChanged;
        const values = dialogResult.selected?.map((item: MatListOption) => item.value ?? []);
        const result = options?.multiple ? values : values?.pop();
        return { result, muteChanged };
      })
    );
  };

  openAdvancedCommands = (
    advancedCommands: AdvancedCommand[],
    deviceId: string,
    caseId: string
  ) => {
    const dialogRef = this.matDialog.open(AdvancedCommandsDialogComponent, {
      disableClose: true,
      autoFocus: false,
      closeOnNavigation: true,
      data: {
        advancedCommands: advancedCommands,
        deviceId: deviceId,
        caseId: caseId
      },
      panelClass: "mat-mdc-dialog-advanced-commands"
    });

    return dialogRef.afterClosed();
  };
}
